import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import ChildWorkItemsIcon from '@atlaskit/icon/core/child-work-items';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-all-fields-action-renderer.ui.action-card.parent-issue-field.icon-label',
		defaultMessage: 'Parent issue field icon',
		description:
			'Accessible label for the icon representing the parent issue field in a Jira work item action card.',
	},
});

export function ParentIssueFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<ChildWorkItemsIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
